exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".validation-message{position:absolute;left:0;top:calc(100% + .25rem);color:red;font-size:.75rem}@media screen and (max-width:29.4375em){.form-row .validation-message{left:.75rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/FormValidationMessage/FormValidationMessage.scss
// module id = 679
// module chunks = 0